import type {
  ClientBan,
  ClientCodexEntry,
  ClientCombatRecord,
  ClientInventoryItem,
  ClientMute,
  ClientUserInfo,
  ClientUserSearchResults,
  DuelOffer,
} from '@game/shared-types';
import type { VirtuosoHandle } from 'react-virtuoso';

import type { BugReport } from '@validators/bugReport';

import type { UpdateLogEntry } from '../types/ui.types';

export type SendItemRecipient =
  | {
      type: 'corporation';
    }
  | {
      type: 'user';
      name: string;
    };

export interface UIState {
  serverTime: number;
  serverTimeOffset: number;
  changingLocation: boolean;
  changingArea: boolean;
  foundNames: string[];
  foundUsers?: ClientUserSearchResults[];
  isNameAvailable?: boolean;
  isPartyNameAvailable?: boolean;
  userInfo?: ClientUserInfo;
  deleteAccountSuccess?: boolean;
  latestUpdate?: UpdateLogEntry;
  updateLogs?: UpdateLogEntry[];
  latestCodex?: ClientCodexEntry;
  codex?: ClientCodexEntry;
  getCodexSuccess?: boolean;
  equipSkillName?: string;
  unequipSkillName?: string;
  unlearnSkillName?: string;
  combatRecords?: ClientCombatRecord[];
  sortedInventory: ClientInventoryItem[];
  ctrlKeyDown: boolean;
  shiftKeyDown: boolean;
  duelOffer?: DuelOffer;
  duelOfferTimeRemaining: number;
  energyIncrement: number;
  energyMinuteInterval: number;
  spiritIncrement: number;
  spiritMinuteInterval: number;
  waitingForCombatStart: boolean;
  chatInputRef: HTMLInputElement | null;
  virtuosoRef: VirtuosoHandle | null;
  sendItemRecipient: SendItemRecipient;
  bans: ClientBan[];
  mutes: ClientMute[];
  openBugs: BugReport[];
  closedBugs: BugReport[];
  userBugReports: BugReport[];
  knownVersion?: string;
  newVersionAvailable: boolean;
}

export const uiDefault: UIState = {
  serverTime: 0,
  serverTimeOffset: 0,
  changingLocation: false,
  changingArea: false,
  foundNames: [],
  sortedInventory: [],
  ctrlKeyDown: false,
  shiftKeyDown: false,
  duelOfferTimeRemaining: -1,
  energyIncrement: 0,
  energyMinuteInterval: 0,
  spiritIncrement: 0,
  spiritMinuteInterval: 0,
  waitingForCombatStart: true,
  chatInputRef: null,
  virtuosoRef: null,
  sendItemRecipient: {
    type: 'user',
    name: '',
  },
  bans: [],
  mutes: [],
  openBugs: [],
  closedBugs: [],
  userBugReports: [],
  newVersionAvailable: false,
};
